import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import betterNavigatorLanguage from './better-navigator-language'

function getDetectors() {
  const detectors = new LanguageDetector()
  detectors.addDetector(betterNavigatorLanguage)
  return detectors
}

export const initI18n = resources => {
  i18n
    .use(getDetectors())
    .use(initReactI18next)
    .init({
      resources: resources,
      fallbackLng: 'en',
      whitelist: Object.keys(resources),
      detection: {
        order: ['querystring', 'cookie', 'localStorage', 'betterNavigatorLanguage', 'navigator', 'htmlTag'],
        whitelist: Object.keys(resources) // non standard but useful for our custom detector
      }
    })

  return i18n
}

export default i18n
